import React from 'react';
import type { PluginProps } from 'ricos-types';

import type { LinkPreviewPluginEditorConfig } from '../types';
import { LinkPreviewViewer } from '../viewer/link-preview-viewer';

export const LinkPreview: React.FC<PluginProps> = ({ settings, componentData, node }) => {
  return (
    <LinkPreviewViewer
      nodeId={node.attrs.id}
      settings={settings as LinkPreviewPluginEditorConfig}
      iframeSandboxDomain={''}
      componentData={componentData}
    />
  );
};
